module.exports = {"countries":[{"name":"United States","abbreviation":"US"},{"name":"Canada","abbreviation":"CA"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/CountryOptions/locales/en.json
// module id = 1177
// module chunks = 0